import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock } from 'lucide-react';
import { Button } from '../../components/ui/Button';
interface AssessmentHeaderProps {
  currentQuestion: number;
  totalQuestions: number;
  elapsedMs: number;
  onExit: () => void;
  onPrevious?: () => void;
  canGoPrevious: boolean;
  answeredIndices?: Set<number>;
}
export function AssessmentHeader({
  currentQuestion,
  totalQuestions,
  elapsedMs,
  onExit,
  onPrevious,
  canGoPrevious,
  answeredIndices = new Set()
}: AssessmentHeaderProps) {
  const minutes = Math.floor(elapsedMs / 60000);
  const seconds = Math.floor(elapsedMs % 60000 / 1000);
  const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const progressPercentage = currentQuestion / totalQuestions * 100;
  return <header className="fixed top-0 left-0 right-0 bg-white border-b border-slate-200 shadow-sm flex flex-col z-50" data-id="element-841">
      {/* Mobile Progress Bar (Top edge) */}
      <div className="h-1 w-full bg-slate-100 sm:hidden" data-id="element-842">
        <motion.div className="h-full bg-indigo-600" initial={{
        width: 0
      }} animate={{
        width: `${progressPercentage}%`
      }} transition={{
        duration: 0.3
      }} data-id="element-843" />
        
      </div>

      <div className="h-16 flex items-center justify-between px-4 sm:px-6" data-id="element-844">
        {/* Left: Exit & Previous */}
        <div className="flex items-center gap-2 sm:gap-4 w-1/3" data-id="element-845">
          <Button variant="ghost" size="sm" onClick={onExit} className="text-slate-500 hover:text-slate-900 hover:bg-slate-100" data-id="element-846">
            
            Stoppen
          </Button>

          {onPrevious && <Button variant="ghost" size="sm" onClick={onPrevious} disabled={!canGoPrevious} className="flex text-slate-500 hover:text-slate-900 hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-847">
            
              <ArrowLeft className="w-4 h-4 sm:mr-1.5" data-id="element-848" />
              <span className="hidden sm:inline" data-id="element-849">Vorige</span>
            </Button>}
        </div>

        {/* Center: Progress & Badge */}
        <div className="flex-1 flex flex-col items-center justify-center" data-id="element-850">
          <div className="flex items-center gap-2 mb-1.5" data-id="element-851">
            <div className="text-slate-700 text-sm font-bold" data-id="element-852">
              Vraag {currentQuestion} van {totalQuestions}
            </div>
          </div>

          {/* Desktop Dots */}
          <div className="hidden sm:flex items-center gap-1.5 justify-center" data-id="element-853">
            {Array.from({
            length: totalQuestions
          }).map((_, i) => {
            const isCurrent = i === currentQuestion - 1;
            const isAnswered = answeredIndices.has(i);
            return <div key={i} className={`
                    w-2 h-2 rounded-full transition-all duration-300
                    ${isCurrent ? 'bg-indigo-600 scale-125 ring-2 ring-indigo-100' : isAnswered ? 'bg-indigo-300' : 'bg-slate-200'}
                  `} data-id="element-854" />;
          })}
          </div>
        </div>

        {/* Right: Timer */}
        <div className="w-1/3 flex justify-end" data-id="element-855">
          <div className="flex items-center gap-2 text-slate-600 bg-slate-100 px-3 py-1.5 rounded-full font-mono text-sm font-medium border border-slate-200" data-id="element-856">
            <Clock className="w-4 h-4 text-slate-400" data-id="element-857" />
            {timeString}
          </div>
        </div>
      </div>
    </header>;
}